import axios from 'axios';
import axiosInstance from './AxiosInstance';
import { store } from '../store/store';

export const getMerchantInvoiceList = (getData) => {
  return axiosInstance.get("merchant-invoice/list", {
    params: getData,
  });
};

const getAuthHeaders = () => {
  const token = store.getState()?.auth?.auth?.accessToken;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const downloadMerchantInvoice = (getData) => {
  return axios.get(`${process.env.REACT_APP_BASE_URL}/merchant-invoice/download`, {
    params: getData,
    responseType: 'blob',
    withCredentials: true,
    headers: {
      ...getAuthHeaders(),
      'Cache-Control': 'no-cache',
    },
  });
};

export const downloadMerchantInvoicePdf = (getData) => {
  return axios.get(`${process.env.REACT_APP_BASE_URL}/merchant-invoice/html`, {
    params: getData,
    responseType: 'blob',
    withCredentials: true,
    headers: {
      ...getAuthHeaders(),
      'Cache-Control': 'no-cache',
    },
  });
};
